import { Link } from 'react-router';
import { useMeetingProject } from '../lib/team-projects.js';
import { useSession } from '../state/session.js';
import { Spinner } from './ui.js';

export function TeamMeetingPicker() {
  const { user, projects } = useSession();
  const teams = useMeetingProject(user?.id, projects);
  return <section className="card stack" aria-label="Calls and meetings in My space">
    <strong>Calls and meetings use a team project</strong>
    <p className="muted small">My space is for your private text conversations. Choose a team project for a call or meeting; its members can see the transcript.</p>
    {teams.loading ? <Spinner label="Finding your recent team project" /> : teams.selected ? <>
      <label className="row">Team project <select aria-label="Team project for calls and meetings" value={teams.selected.id} onChange={event => teams.choose(event.target.value)}>
        {teams.projects.map(project => <option key={project.id} value={project.id}>{project.name}</option>)}
      </select></label>
      <div className="row">
        <Link className="btn btn-primary" to={`/p/${teams.selected.id}`} onClick={() => teams.choose(teams.selected!.id)}>Open project to call or meet</Link>
        <Link className="btn" to={`/meetings?project=${teams.selected.id}`} onClick={() => teams.choose(teams.selected!.id)}>Meetings</Link>
      </div>
    </> : <p className="muted small">No active team project is available. Ask a project owner to add you to one.</p>}
  </section>;
}
